<template>
    <main>
        <NewsDialog ref="newsDialog" :isAdmin="true"/>
        <v-table
            id="clinicNewsTable"
            request-uri="news/published/getList"
            pagesize="50"
            ref="table"
        >
            <template v-slot:header>
                <v-tr>
                    <v-th name="clinicName" width="200">
                        Клиника
                    </v-th>
                    <v-th name="description" minwidth="200">
                        Описание
                    </v-th>
                    <v-th name="created" sort="created_at" width="85" highlight="*">
                        Добавлена
                    </v-th>
                </v-tr>
                <v-tr>
                    <v-th name="clinicName" :debounce="true" v-slot="{filter}" width="200">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="description" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value"/>
                    </v-th>
                    <v-th name="created" v-slot="{filter}">
                        <date-picker v-model="filter.value"/>
                    </v-th>
                </v-tr>
            </template>
            <template v-slot:row="{ item, index, indexOnPage }">
                <v-tr :class="['hover', 'pointer']" @click="(row, event) => handleRowClick(event, row, item)">
                    <v-td name="clinicName" width="200">
                        <div v-for="clinic in item.clinics" :class="[{'warning': clinic.isModerationSource}]">
                            <div class="text-ellipsis">
                                {{clinic.name}}
                            </div>
                        </div>
                        <div v-for="network in item.networkModerationSources" class="warning">
                            <div class="text-ellipsis">
                                Сетевой Аккаунт ({{network.name}})
                            </div>
                        </div>
                    </v-td>
                    <v-td name="description">
                        <span class="max5LinesText" v-html="item.description" />
                    </v-td>
                    <v-td name="created" highlight="*">
                        {{ item.created_at | formatDate }}
                    </v-td>
                </v-tr>
            </template>
        </v-table>
    </main>
</template>
<script>
import NewsDialog from "@/components/dialogs/NewsDialog";
import DatePicker from "@base/DatePicker";

export default {
    components: {NewsDialog, 'date-picker': DatePicker,},
    methods:{
        handleRowClick(event, row, item) {
            row.startLoadingAnimation();
            this.axios.get('/admin/moderation/news/published/read/' + item.id)
                .then(response => {
                    this.$refs.newsDialog.read(response.data, response.data.city, response.data.url)
                    row.stopLoadingAnimation()
                })
                .catch(() => row.stopLoadingAnimation());
        },
    }
}
</script>
<style lang="scss">
#clinicNewsTable span.max5LinesText {
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;

    & p{
        margin: 0;
    }
}
</style>
